import { api } from './api';

const RESOURCE_PATH = `/templates/statistics/`;

export const StatisticsApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getTemplateStatistics: builder.query<any, void>({
      query: () => RESOURCE_PATH,
      providesTags: [{ type: 'TemplateStatistics', id: 'STATISTICS' }],
    }),
  }),
});

export const { useGetTemplateStatisticsQuery } = StatisticsApi;